import sha1 from "sha1";
import { fetch, post, fetch1, post1, fetch2, post2 } from "@/axios/index.js";
import { INQUIRY_URL, AUTH_URL } from "../util/config";
import {getRandomString} from "../util/utils";

//更新用户信息
//data[type Object]
export const updateUserData = (data, token) => {
  return post("/oauth/user/update", token, data);
};

//注册用户
//data[type Object] username:登录用户名 password: 密码
export const registerUser = data => {
  return post("/oauth/register", "", data, 0);
};

//用户登录
//data[type Object] username:登录用户名 password: 密码
export const userLogin = data => {
  return post("/oauth/login", "", data, 0);
};

//获取用户信息
export const getUserData = token => {
  return fetch("/oauth/user/basic", token);
};

//获取国家
export const getCountry = () => {
  return fetch("/oauth/country", "", "", 0);
};

//获取模块的配置信息  1-拼图活动
export const getPuzzleConfigure = data => {
  return fetch1("/api/activity/detail", "", data, 0);
};

//获取抽奖配置信息
export const getLuckDrawConfigure = (data, token) => {
  if (token) return fetch1("/api/activity/detail", token, data);
  else return fetch1("/api/activity/detail", "", data, 0);
};

//获取抽奖结果
export const getLuckDrawResult = (data, token) => {
  return fetch1("/api/activity/draw", token, data);
};

/**
 *  提交结果
 * params
 * Object data: cost_time - 用时, activity_id - 活动id
 * String token
 */
export const submitAddTime = (data, token) => {
  const { cost_time = "", activity_id = "" } = data;
  if(!cost_time||!activity_id) return ;
  const timestamp = parseInt(new Date().getTime()/1000);
  const nonce = getRandomString(8); // 生成随机字符串
  const signature = sha1((timestamp%1024)+nonce+activity_id+cost_time);
  return post1("/api/activity/add_rank_info", token, {
    signature,
    timestamp,
    nonce,
    cost_time,
    activity_id
  });
};

//提交中奖用户信息
export const submitWinnerInfo = (data, token) => {
  return post1("/api/activity/update_user", token, data);
};

//拼图获取自己的最佳排名信息
export const getMyRank = (data, token) => {
  return fetch1("/api/activity/get_rank_info", token, data);
};

//拼图排名列表  activity_id：1 拼图活动
export const getRankList = data => {
  return fetch1("/api/activity/rank_lists", "", data, 0);
};

//获取当前时间能排到第几
export const getCurrentRank = (data, token) => {
  return fetch1("/api/activity/get_current_rank", token, data);
};

//积分打卡 点击签到
export const signIn = (data, token) => {
  return post1("/api/activity/sign", token, data);
};

//获取微信分享配置
export const getWxConfig = data => {
  // return fetch("/wechat/index/jssdk", "", data, 0, "GET", INQUIRY_URL);
  return fetch("/wechat/index/jssdk", "", data, 0, INQUIRY_URL);
};

//获取用户信息
export const getWxUser = code => {
  return fetch("/weixin/get_user?code=" + code, "", "", 0, AUTH_URL);
};



// WEBPACK FOOTER //
// ./src/util/data.js